export default __webpack_public_path__ + "static/1-c984228c28a6d8a4514318c85788fc5f.png";